import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useId, useRef, useState } from "react";

export default function ExpandiableModel() {
  const [active, setActive] = useState(null);
  const [images, setImages] = useState([]);

  const ref = useRef(null);
  const id = useId();
  useEffect(() => {
    const CF_URL = process.env.REACT_APP_CLOUDFRONT_URL;
    async function load() {
      try {
        const res = await fetch(`${CF_URL}/data/aboutData.json`, {
          method: "GET",
          mode: "cors",
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        setImages(json.data.images);
      } catch (err) {
        console.error(err);
      }
    }
    load();
  }, []);

  useEffect(() => {
    function onKeyDown(event) {
      if (event.key === "Escape") {
        setActive(false);
      }
    }

    if (active && typeof active === "object") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [active]);
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      setActive(null);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref]);
  return (
    <>
      <AnimatePresence>
        {active && typeof active === "object" && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/20 h-full w-full z-50"
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {active && typeof active === "object" ? (
          <div className="fixed inset-0 top-20  lg:top-16  grid place-items-center z-50">
            <motion.button
              key={`button-${active.title}-${id}`}
              layout
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              exit={{
                opacity: 0,
                transition: {
                  duration: 0.05,
                },
              }}
              className="flex absolute top-2 right-2 lg:hidden items-center justify-center bg-white rounded-full h-6 w-6"
              onClick={() => setActive(null)}
            >
              <CloseIcon />
            </motion.button>
            <motion.div
              layoutId={`card-${active.title}-${id}`}
              ref={ref}
              className="w-full max-w-[500px]  h-full md:h-fit md:max-h-[90%]  flex flex-col bg-zinc-800 sm:rounded-3xl overflow-hidden"
            >
              <motion.div
                className="flex space-x-4"
                layoutId={`image-${active.title}-${id}`}
              >
                <img src={active.src} alt={active.title} className="w-3/6 " />
                <motion.div className="flex flex-col justify-center">
                  <motion.h3
                    layoutId={`title-${active.title}-${id}`}
                    className="font-bold bg-zinc-800 capitalize text-2xl"
                  >
                    {active.title}
                  </motion.h3>
                  <motion.p className="bg-zinc-800 text-sm md:text-base lg:text-lg text-gray-400">
                    Artistic Director
                  </motion.p>
                </motion.div>
              </motion.div>

              <div>
                <div className="pt-4 relative px-4 mb-10">
                  <motion.div
                    layout
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="bg-zinc-800 text-xs md:text-sm lg:text-base h-40 md:h-52 flex flex-col items-start gap-4 overflow-y-scroll [mask:linear-gradient(to_bottom,white,white,transparent)] [scrollbar-width:none] [-ms-overflow-style:none] [-webkit-overflow-scrolling:touch]"
                  >
                    <p className="mb-10">{active.desc}</p>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          </div>
        ) : null}
      </AnimatePresence>
      {images.length > 0 &&
        images?.map((image) => (
          <motion.div
            layoutId={`card-${image.title}-${id}`}
            key={`card-${image.title}-${id}`}
            onClick={() => setActive(image)}
          >
            <motion.div layoutId={`image-${image.title}-${id}`}>
              <img
                src={image.src}
                alt={image.title}
                className=" pointer-events-auto cursor-pointer rounded-full m-5 h-28 lg:h-32 transform hover:scale-110 transition-transform duration-500"
              />
            </motion.div>
            {/* <motion.button
              layoutId={`button-${image.title}-${id}`}
              className="px-4 py-2 text-sm rounded-full font-bold bg-gray-100 hover:bg-green-500 hover:text-white text-black mt-4 md:mt-0"
            >
              {card.ctaText}
            </motion.button> */}
          </motion.div>
        ))}
    </>
  );
}

export const CloseIcon = () => {
  return (
    <motion.svg
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.05,
        },
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4 text-black"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M18 6l-12 12" />
      <path d="M6 6l12 12" />
    </motion.svg>
  );
};

// const cards = [
//   {
//     description: "Lana Del Rey",
//     title: "Summertime Sadness",
//     src: "https://assets.aceternity.com/demos/lana-del-rey.jpeg",
//     ctaText: "Play",
//     ctaLink: "https://ui.aceternity.com/templates",
//     content: () => {
//       return (
//         <p>
//           Lana Del Rey, an iconic American singer-songwriter, is celebrated for
//           her melancholic and cinematic music style. Born Elizabeth Woolridge
//           Grant in New York City, she has captivated audiences worldwide with
//           her haunting voice and introspective lyrics. <br /> <br />
//           Her songs often explore themes of tragic romance, glamour, and
//           melancholia, drawing inspiration from both contemporary and vintage
//           pop culture. With a career that has seen numerous critically acclaimed
//           albums, Lana Del Rey has established herself as a unique and
//           influential figure in the music industry, earning a dedicated fan base
//           and numerous accolades.
//         </p>
//       );
//     },
//   },
//   {
//     description: "Babbu Maan",
//     title: "Mitran Di Chhatri",
//     src: "https://assets.aceternity.com/demos/babbu-maan.jpeg",
//     ctaText: "Play",
//     ctaLink: "https://ui.aceternity.com/templates",
//     content: () => {
//       return (
//         <p>
//           Babu Maan, a legendary Punjabi singer, is renowned for his soulful
//           voice and profound lyrics that resonate deeply with his audience. Born
//           in the village of Khant Maanpur in Punjab, India, he has become a
//           cultural icon in the Punjabi music industry. <br /> <br />
//           His songs often reflect the struggles and triumphs of everyday life,
//           capturing the essence of Punjabi culture and traditions. With a career
//           spanning over two decades, Babu Maan has released numerous hit albums
//           and singles that have garnered him a massive fan following both in
//           India and abroad.
//         </p>
//       );
//     },
//   },

//   {
//     description: "Metallica",
//     title: "For Whom The Bell Tolls",
//     src: "https://assets.aceternity.com/demos/metallica.jpeg",
//     ctaText: "Play",
//     ctaLink: "https://ui.aceternity.com/templates",
//     content: () => {
//       return (
//         <p>
//           Metallica, an iconic American heavy metal band, is renowned for their
//           powerful sound and intense performances that resonate deeply with
//           their audience. Formed in Los Angeles, California, they have become a
//           cultural icon in the heavy metal music industry. <br /> <br />
//           Their songs often reflect themes of aggression, social issues, and
//           personal struggles, capturing the essence of the heavy metal genre.
//           With a career spanning over four decades, Metallica has released
//           numerous hit albums and singles that have garnered them a massive fan
//           following both in the United States and abroad.
//         </p>
//       );
//     },
//   },
//   {
//     description: "Led Zeppelin",
//     title: "Stairway To Heaven",
//     src: "https://assets.aceternity.com/demos/led-zeppelin.jpeg",
//     ctaText: "Play",
//     ctaLink: "https://ui.aceternity.com/templates",
//     content: () => {
//       return (
//         <p>
//           Led Zeppelin, a legendary British rock band, is renowned for their
//           innovative sound and profound impact on the music industry. Formed in
//           London in 1968, they have become a cultural icon in the rock music
//           world. <br /> <br />
//           Their songs often reflect a blend of blues, hard rock, and folk music,
//           capturing the essence of the 1970s rock era. With a career spanning
//           over a decade, Led Zeppelin has released numerous hit albums and
//           singles that have garnered them a massive fan following both in the
//           United Kingdom and abroad.
//         </p>
//       );
//     },
//   },
//   {
//     description: "Mustafa Zahid",
//     title: "Toh Phir Aao",
//     src: "https://assets.aceternity.com/demos/toh-phir-aao.jpeg",
//     ctaText: "Play",
//     ctaLink: "https://ui.aceternity.com/templates",
//     content: () => {
//       return (
//         <p>
//           "Aawarapan", a Bollywood movie starring Emraan Hashmi, is renowned for
//           its intense storyline and powerful performances. Directed by Mohit
//           Suri, the film has become a significant work in the Indian film
//           industry. <br /> <br />
//           The movie explores themes of love, redemption, and sacrifice,
//           capturing the essence of human emotions and relationships. With a
//           gripping narrative and memorable music, "Aawarapan" has garnered a
//           massive fan following both in India and abroad, solidifying Emraan
//           Hashmi's status as a versatile actor.
//         </p>
//       );
//     },
//   },
// ];
